<template>
  <v-card v-if = "renderComponent" class="card-parent">
    <div class="padding-child">
      <v-form ref="form" validation v-model="valid">
        <div class="web-image input-image">
            <v-file-input
                v-model="webFiles"
                class="input"
                chips
                :placeholder="webImageDes"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                v-on:change="showWebImage($event)"
                v-on:click:clear="deleteWebImage"
                hide-details
            ></v-file-input>
          <v-img style="max-width: 200px" width="200" height="150" :src="imageUserWeb"></v-img>
        </div>
        <div class="mobile-image input-image">
              <v-file-input
                v-model="mobileFiles"
                class="input"
                chips
                :placeholder="mobileImageDes"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                v-on:change="showMobileImage($event)"
                v-on:click:clear="deleteMobileImage"
                hide-details
              ></v-file-input>
          <v-img style="max-width: 200px" width="200" height="150" :src="imageUserMobile"></v-img>

        </div>
      </v-form>
      <div style="display: flex;justify-content: flex-end">
        <v-btn :loading="deleteLoading" v-show="isEdit" class="button" :disabled="!valid" @click="deleteBanner()">حذف</v-btn>
        <v-btn :loading="sendLoading" v-show="!isEdit" class="button" :disabled="!valid" @click="send()">فرستادن</v-btn>
        <v-btn :loading="editLoading" v-show="isEdit" class="button" :disabled="!valid" @click="update()">ویرایش</v-btn>
      </div>


    </div>
    <div v-show="isEdit" class="images" v-for="item in originalBanner">
      <div class="webPage">
        <p style="font-weight: bold;font-size:1.5rem">عکس وب:</p>
        <v-img lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU" width="300" height="200" :src="baseUrl+item.webImgPath+ '?'+ dates">
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>
      <div class="mobilePage">
        <p style="font-weight: bold;font-size:1.5rem">عکس موبایل:</p>
        <v-img lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU" width="300" height="200" :src="baseUrl+item.mobileImgPath+ '?'+ dates">
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>
    </div>
  </v-card>
</template>

<script>
  import FormInput from "./formInput";
  import {toBase64} from "../../../plugins/toBase64";
  import {putOccationalBanner, deleteOccationalBanner, setOccationalBanner} from "../../../api/mainpage/occationalBanner";
  import {mapActions, mapGetters} from "vuex";
  export default {
    name: "occationalBanner",
    components: {FormInput},
    data:()=>({
      baseUrl:'',
      webFiles:[],
      renderComponent: true,
      sendLoading:false,
      editLoading:false,
      deleteLoading:false,
      check:true,
      mobileFiles:[],
      webImageDes:'عکس مورد نظر رو برای اندازه وب وارد کنید',
      mobileImageDes:'عکس مورد نظر رو برای اندازه موبایل وارد کنید',
      isEdit:true,
      valid:true,
      imageUserWeb:'',
      imageUserMobile:'',
      dates:''
    }),
    methods:{
      showWebImage(e){
        if(e) {
          this.imageUserWeb = URL.createObjectURL(e)
        }
      },
      deleteWebImage()
      {
        this.imageUserWeb = ''
      },
      showMobileImage(e){
        if(e) {
          this.imageUserMobile = URL.createObjectURL(e)
        }
      },
      deleteMobileImage()
      {
        this.imageUserMobile = ''
      },
      ...mapActions({
        getBannerReq:'occationalBanner/fetchBanner',
        snackBarAction:'snackBar/snackBarAction'
      }),
      async deleteBanner(){
        this.deleteLoading= true
        let yes = confirm("مطمئنی !");
        if(yes){
          await deleteOccationalBanner(this.originalBanner[0].id).then(()=>{
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
            this.isEdit = false
            this.dates = new Date()
          }).catch(()=>{
          this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          })
          }
        this.deleteLoading = false
      },
      async send(){
        this.sendLoading = true
        let web = await toBase64(this.webFiles)
        let mobile = await toBase64(this.mobileFiles)
        try {
          await setOccationalBanner({
            webImgPath: web,
            mobileImgPath:mobile,
          }).then(()=>{
            this.deleteWebImage()
            this.deleteMobileImage()
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
            this.dates = new Date()
            this.getBannerReq().then(()=>{
              this.isEdit = true
            })
            this.webFiles = []
            this.mobileFiles=[]
          }).catch(()=>{
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          })
        }catch (e) {

        }
        this.sendLoading = false
      },
      async update(){
        this.editLoading = true
        let web =  this.webFiles ? await  toBase64(this.webFiles)  : null
        let mobile =this.mobileFiles ?  await toBase64(this.mobileFiles) : null
        try {
          await putOccationalBanner({
            webImgPath: web,
            mobileImgPath:mobile,
            id:this.originalBanner[0].id
          },this.originalBanner[0].id).then(()=>{
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
            this.getBannerReq().then(()=>{
              this.isEdit = true;
            });
            this.dates = new Date()
            this.webImgPath = []
            this.mobileImgPath=[]
          }).catch(()=>{
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})})
        }catch (e) {
          /////
        }
        this.editLoading = false
      },

    },

    computed: {
      ...mapGetters({
        originalBanner: 'occationalBanner/get_banner',
      })
    },
    async mounted() {
      this.dates = new Date()
      this.baseUrl = process.env.VUE_APP_BASE_URL
      await this.getBannerReq().then(()=>{
        this.isEdit = this.originalBanner.length !== 0;
      })

    }
  }
</script>

<style scoped>

  .row{
    justify-content: center;
    align-items: flex-end;
    flex-direction: row-reverse;
  }
  .text{
    font-family: anjoman;
    font-size: 1.25rem;
  }

  .card-parent{
    width: 85%;
    margin: 0 auto;
  }
  .padding-child{
    padding: 50px 50px 20px;
    display: flex;
    flex-direction: column;
  }
  .button{
    align-self: flex-end;
  }
  .banner{
    padding: 0 50px 20px;
  }
  .images{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    position: relative;
    padding-right: 50px;
    padding-left: 50px;
    padding-bottom: 50px;
  }
  .input-image{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
  }
  .input{
    max-width: 300px;
  }

  .icons{
    position: absolute;
    top: 0;
    left: 0;
  }
</style>
